// modules
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

// imports
import { EmptyState } from './empty-state.component';
import { IconModule } from '../icon/icon.module';
import { ButtonModule } from '../button/button.module';

@NgModule({
  declarations: [
    EmptyState,
  ],
  exports: [
    EmptyState,
  ],
  imports: [
    CommonModule,
    IconModule,
    ButtonModule,
  ]
})
class EmptyStateModule { }

export { EmptyState, EmptyStateModule };
